import { initGtm } from '@link/share/vendors/gtm';

initGtm({
  gtmId: 'GTM-PN36N79',
  environment: import.meta.env.VITE_APP_SKYTREE_ENV || '',
  environments: ['develop', 'testing', 'production', 'production-jp']
});
